import { functions } from '@/firebase';
import { OrderWithId } from '@/types/functions';

export async function getOrders(): Promise<OrderWithId[]> {
  const getOrdersFN = functions.httpsCallable('getOrders');
  const { data }: { data: OrderWithId[] } = await getOrdersFN();

  return data;
}
